import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { MatSnackBar, MatDialog } from '@angular/material';
import { LearnerService } from '../../services/learner.service';
import * as _ from 'lodash';
import { UserRoleService } from '../../services/user-role.service';
@Component({
  selector: 'app-casestudy-mark-scheme',
  templateUrl: './casestudy-mark-scheme.component.html',
  styleUrls: ['./casestudy-mark-scheme.component.scss']
})
export class CasestudyMarkSchemeComponent implements OnInit {


  caseStudyForm
  @Input('learner') learnerData;
  @Input('singleJob') jobData;
  @Input('assesment') assessmentPlanEdit;
  singleLearner: any;
  learnerId: any;
  jobId: any;
  assessmentEdit: any;
  firstSectionTotal = []
  secondSectionTotal = []
  thirdSectionTotal = []
  firstSection = 0
  loading = false
  isEdit: boolean = false;
  currentUser: any;
  user: any;
  isAdmin: boolean = false;
  isLearner: boolean = false;
  isIQA: boolean = false;
  isTrainer: boolean = false;
  constructor(
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _learnerService: LearnerService,
    public _userRoleService : UserRoleService
  ) { }

  ngOnInit() {
    if(!this.isEdit)
      this.createForm()
  }



  ngOnChanges(changes: SimpleChanges) {
    console.log("changes in master rail main", changes);
    if (changes.learnerData && changes.learnerData.currentValue) {
      // this.singleLearner = changes.learnerData.currentValue
      this.learnerId = changes.learnerData.currentValue
    }

    if (changes.jobData && changes.jobData.currentValue) {
      this.jobId = changes.jobData.currentValue[0]
      this.getUserRole();
    }
    if (changes.assessmentPlanEdit && changes.assessmentPlanEdit.currentValue) {
      console.log("changes.assessmentPlanEdit.currentValue in master", changes.assessmentPlanEdit.currentValue)
      this.assessmentEdit = changes.assessmentPlanEdit.currentValue
      console.log("assement plan edit data", this.assessmentEdit);
      if (this.assessmentEdit && this.assessmentEdit.caseStudyForm) {
        this.firstSectionTotal = this.assessmentEdit.caseStudyForm.firstTotal ? this.assessmentEdit.caseStudyForm.firstTotal : []
        this.secondSectionTotal = this.assessmentEdit.caseStudyForm.secondTotal ? this.assessmentEdit.caseStudyForm.secondTotal : []
        this.thirdSectionTotal = this.assessmentEdit.caseStudyForm.thirdTotal ? this.assessmentEdit.caseStudyForm.thirdTotal : []
      }
      this.isEdit = true
      this.createForm(this.assessmentEdit)

    }
    else {
      this.createForm()
    }
  }
  getUserRole(){
    let getRole = this._userRoleService.getUserRole(this.jobId.instructors,'job');
    if (getRole.isAdmin) this.isAdmin = true
    else if(getRole.isLearner) this.isLearner = true
    else if(getRole.isTrainer) this.isTrainer = true
    else if(getRole.isIQA) this.isIQA = true

  }




  // FORM CONTROL


  createForm(details?) {
    this.caseStudyForm = new FormGroup({
      mark: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark : ''),
      mark1: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark1 : ''),
      mark2: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark2 : ''),
      mark3: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark3 : ''),
      mark4: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark4 : ''),
      mark5: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark5 : ''),
      mark6: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark6 : ''),
      mark7: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark7 : ''),
      mark8: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark8 : ''),
      mark9: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark9 : ''),
      mark10: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark10 : ''),
      mark11: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark11 : ''),
      mark12: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark12 : ''),
      mark13: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark13 : ''),
      mark14: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark14 : ''),
      mark15: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark15 : ''),
      mark16: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark16 : ''),
      mark17: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark17 : ''),
      mark18: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark18 : ''),
      mark19: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark19 : ''),
      mark20: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark20 : ''),
      mark21: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark21 : ''),
      mark22: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark22 : ''),
      mark23: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark23 : ''),
      mark24: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark24 : ''),
      mark25: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark25 : ''),
      mark26: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark26 : ''),
      mark27: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark27 : ''),
      mark28: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark28 : ''),
      mark29: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark29 : ''),
      mark30: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark30 : ''),
      mark31: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark31 : ''),
      mark32: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark32 : ''),
      mark33: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark33 : ''),
      mark34: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark34 : ''),
      mark35: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark35 : ''),
      mark36: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark36 : ''),
      mark37: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark37 : ''),
      mark38: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark38 : ''),
      mark39: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.mark39 : ''),
      feedBack: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.feedBack : ''),
      sectionTotal: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.sectionTotal : ''),
      sectionTotal1: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.sectionTotal1 : ''),
      sectionTotal2: new FormControl((details && details.caseStudyForm) ? details.caseStudyForm.sectionTotal2 : ''),
    })
  }




  // UTILITY

  firstTotal(event, formControl) {
    console.log("event when enter any number", event.target.value);
    let item = this.caseStudyForm.get(formControl).value
    console.log("this is the value of form control", this.firstSectionTotal);
    let obj = {
      formcontrol: formControl,
      value: Number(item)
    }

    let index = this.firstSectionTotal.findIndex((x) => x.formcontrol == formControl)
    console.log("what is index", index);

    if (index == -1) {
      this.firstSectionTotal.push(obj)
    } else {
      this.firstSectionTotal[index].value = Number(item)
    }


    if (this.firstSectionTotal && this.firstSectionTotal.length) {
      let firstTotal = 0
      this.firstSectionTotal.forEach((item) => {
        firstTotal = firstTotal + Number(item.value)
      })
      console.log("this is the final total ", firstTotal);
      this.caseStudyForm.patchValue({
        sectionTotal: firstTotal
      })
    }
  }

  secondTotal(event, formControl) {
    console.log("event when enter any number", event.target.value);
    let item = this.caseStudyForm.get(formControl).value
    console.log("this is the value of form control", item);
    let obj = {
      formcontrol: formControl,
      value: Number(item)
    }

    let index = this.secondSectionTotal.findIndex((x) => x.formcontrol == formControl)

    if (index == -1) {
      this.secondSectionTotal.push(obj)
    } else {
      this.secondSectionTotal[index].value = Number(item)
    }


    if (this.secondSectionTotal && this.secondSectionTotal.length) {
      let firstTotal = 0
      this.secondSectionTotal.forEach((item) => {
        firstTotal = firstTotal + Number(item.value)
      })
      console.log("this is the final total ", firstTotal);
      this.caseStudyForm.patchValue({
        sectionTotal1: firstTotal
      })
    }
  }

  thirdTotal(event, formControl) {
    console.log("event when enter any number", event.target.value);
    let item = this.caseStudyForm.get(formControl).value
    console.log("this is the value of form control", item);
    let obj = {
      formcontrol: formControl,
      value: Number(item)
    }

    let index = this.thirdSectionTotal.findIndex((x) => x.formcontrol == formControl)

    if (index == -1) {
      this.thirdSectionTotal.push(obj)
    } else {
      this.thirdSectionTotal[index].value = Number(item)
    }


    if (this.thirdSectionTotal && this.thirdSectionTotal.length) {
      let firstTotal = 0
      this.thirdSectionTotal.forEach((item) => {
        firstTotal = firstTotal + Number(item.value)
      })
      console.log("this is the final total ", firstTotal);
      this.caseStudyForm.patchValue({
        sectionTotal2: firstTotal
      })
    }
  }

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }

  // API CALL


  submitForm() {
    console.log("case study form value", this.caseStudyForm.value);
    // this.caseStudyForm.control['firstTotal'] = this.firstSectionTotal

    let data = {
      learnerId: this.learnerId,
      jobId: this.jobId._id,
      version: true,
      details: {
        caseStudyForm: this.caseStudyForm.value,
      }
    }

    data.details.caseStudyForm['firstTotal'] = this.firstSectionTotal
    data.details.caseStudyForm['secondTotal'] = this.secondSectionTotal
    data.details.caseStudyForm['thirdTotal'] = this.thirdSectionTotal
    console.log("this._learnerService.submitPolicy(data) in assessmant Plan", data)
    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this.loading = false
    }, (err) => {
      this.loading = false
      console.log("policy not accepted", err)
    })
  }



}
